import { Switch } from '@palmetto/dsm-components';

interface LabeledToggleProps {
  id: string;
  label: string;
  ariaLabel: string;
  checked: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}

export const LabeledToggle = ({ id, label, ariaLabel, checked, onChange, disabled }: LabeledToggleProps) => (
  <div className="flex items-center gap-8">
    <label htmlFor={id} aria-label={ariaLabel} className="text-sm">
      {label}
    </label>
    <Switch
      ariaLabel={ariaLabel}
      ids={{ hiddenInput: id }}
      value={checked}
      onChange={onChange}
      disabled={disabled}
    />
  </div>
);
